// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-toolbar__title{text-overflow:ellipsis}.vx-dialog-view--card--mobile{position:relative}.large-actions-wrapper{border-top:1px solid #000}", ""]);
// Exports
module.exports = exports;
